
import './animation.css';


const Animation = (props) => {


    return(
        <div style={{color: props.color,height: props.height,width: props.width}} className="circles">
  <div></div>
  <div></div>
  <div></div>
  <span></span>
</div>
       
    )
}



export default Animation;